import { authAxiosClient } from '@/lib';
import { PaginatedApiResponse, PaginatedData } from '@/types';
import { withLogger } from '@/utils';

import { usersAPIUrls } from '@/features/users/data';
import { Credit } from '../types';

type Param = {
  searchString: string;
  status: Array<Credit['status']>;
  page: number;
  rowsPerPage: number;
};

type Credits = Array<Credit>;
type Return = PaginatedData<Array<Credit>>;

export type GetCredits = {
  param: Param;
  return: Return;
};

export const getCredits = withLogger(
  async ({
    searchString: search,
    status,
    page,
    rowsPerPage: per_page,
  }: Param): Promise<Return> => {
    const { data } = await authAxiosClient.get<PaginatedApiResponse<Credits>>(
      usersAPIUrls.fetchAll,
      {
        params: {
          search,
          status,
          page,
          per_page,
        },
      },
    );

    return data;
  },
);
